var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-progress',{staticClass:"progress",attrs:{"size":"is-small","value":_vm.progressValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }